import { render, staticRenderFns } from "./MerchantAndMerBinDingsEdit.vue?vue&type=template&id=348dc546&"
import script from "./MerchantAndMerBinDingsEdit.vue?vue&type=script&lang=ts&"
export * from "./MerchantAndMerBinDingsEdit.vue?vue&type=script&lang=ts&"
import style0 from "./MerchantAndMerBinDingsEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MerchantAndMerBinDingsEdit.vue"
export default component.exports